angular.module('elfium').service('elfiumToastrService', ['toastr', function (toastr) {
    var that = this;
    that.success = function (message) {
        if (message) {
            toastr.success(message);
        }
    };
    that.warning = function (message) {
        if (message) {
            toastr.warning(message);
        }
    };
    that.error = function (message) {
        if (message) {
            toastr.error(message);
        }
    };
    that.info = function (message) {
        if (message) {
            toastr.info(message);
        }
    };
}]);


// WEBPACK FOOTER //
// ./src/app/components/elfium/elfiumToastrService.ts